import styled, { css } from "styled-components"
import { ExecutionStatus } from "lib/types/workflow"

const statusTheme: Record<
  ExecutionStatus,
  { bg: string; border: string; text: string }
> = {
  completed: { bg: "#dcf4e5", border: "#10b981", text: "#065f46" },
  failed: { bg: "#fee2e2", border: "#ef4444", text: "#991b1b" },
  skipped: { bg: "#f3f4f6", border: "#9ca3af", text: "#6b7280" },
  pending: { bg: "#dbeafe", border: "#3b82f6", text: "#1e40af" }
}

export const StatusBadge = styled.div<{ $status: ExecutionStatus }>`
  position: absolute;
  top: -1.2rem;
  right: -1.2rem;
  width: 2.8rem;
  height: 2.8rem;
  border-radius: 50%;
  border: 0.2rem solid ${(p) => statusTheme[p.$status].border};
  background: ${(p) => statusTheme[p.$status].bg};
  color: ${(p) => statusTheme[p.$status].text};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  ${(p) => p.theme.bold};
  box-shadow: 0 0.1rem 0.3rem rgba(0, 0, 0, 0.15);
  z-index: 2;
`

export const FailedMessageBlock = styled.div`
  margin: 0 1.2rem 0.8rem;
  padding: 0.6rem 0.8rem;
  background: #fef2f2;
  border: 0.1rem solid #fecaca;
  border-radius: 0.4rem;
  color: #991b1b;
  font-size: 1.1rem;
  word-break: break-word;
  white-space: pre-wrap;
  ${(p) => p.theme.bold};
`

export const skippedOpacity = css<{ $skipped?: boolean }>`
  opacity: ${(p) => (p.$skipped ? 0.55 : 1)};
`

export const statusIcon = (status: ExecutionStatus): string => {
  switch (status) {
    case "completed":
      return "✓"
    case "failed":
      return "✗"
    case "skipped":
      return "—"
    case "pending":
      return "·"
  }
}
